module.exports = "/images/logo.svg?e0b2ae29f7aea7fcaf0153e097df8ceb";